<div class="table-w-dropdown-container" [style.marginTop]="data?.marginTop">
  <h3 class="table-title" *ngIf="data?.title">{{ data?.title }}</h3>

  <div class="table-shell">
    <table mat-table [dataSource]="dataSource" class="discount-table"
      [class.terms-conditions-table]="data?.widgetId === 'termsAndConditionsTable'"
      [class.quote-level-discount-table]="data?.widgetId === 'quoteLevelDiscountTable'">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th class="header-cell" [ngClass]="getHeaderCellClasses(column)" [attr.data-column-key]="column" mat-header-cell *matHeaderCellDef>
          {{ formatHeaderLabel(columnLabels[column]) }}
        </th>

        <td class="body-cell" [ngClass]="getBodyCellClasses(column, row)" [attr.data-column-key]="column" mat-cell *matCellDef="let row">
          <ng-container *ngIf="isDropdownColumn(column); else nonDropdownCell">
            <mat-form-field appearance="outline" class="dropdown-field"
              [class.compact-dropdown]="isCompactColumn(column)"
              [class.numeric-dropdown]="isNumericColumn(column, row)">
              <mat-select [multiple]="isMultiSelect(column)" [ngModel]="row[column]"
                (ngModelChange)="onDropdownChange(row, column, $event)"
                [placeholder]="dropdownColumnConfig[column]?.placeholder || 'Select'">
                <mat-option *ngFor="let option of getDropdownOptions(row, column)" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <ng-template #nonDropdownCell>
            <ng-container *ngIf="isInputColumn(column); else textCell">
              <mat-form-field appearance="outline" class="input-field"
                [class.compact-input]="isCompactColumn(column)"
                [class.numeric-input]="isNumericColumn(column, row)">
                <input matInput [type]="getInputType(column, row)"
                  [attr.inputmode]="isNumericColumn(column, row) ? 'decimal' : null"
                  [ngModel]="getInputDisplayValue(column, row[column], row)"
                  (ngModelChange)="onTextInputChange(row, column, $event)"
                  [placeholder]="getInputPlaceholder(column)" />
              </mat-form-field>
            </ng-container>
            <ng-template #textCell>
              {{ getCellDisplayValue(column, row[column], row) }}
            </ng-template>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div class="table-footer-line" *ngIf="shouldShowFooterLine">
    <div class="table-footer-separator"></div>
    <h4 class="table-footer-text">
      {{ footerLineText }}
    </h4>
  </div>
</div>
